import crossroads from "crossroads";
import { sessionStorageProxy } from "./sessionStorage";
const redirectTo = (url, options) => {
    if (options?.target === "_blank") {
        window.open(url, "_blank")?.focus();
    }
    else {
        window.location.assign(url);
    }
};
const triggerAction = (eventName, payload = {}) => {
    window.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
};
const configureRouter = (routes) => {
    Object.entries(routes).forEach(([path, handler]) => {
        crossroads.addRoute(path, handler);
    });
    // redirect to passed URL if no matching routes were found
    crossroads.bypassed.add((options, request) => {
        redirectTo(request, options);
    });
    crossroads.ignoreState = true;
    return crossroads;
};
const redirectWithQueryTo = (url, query) => {
    if (!query)
        throw new Error("malformed query");
    const queryString = "?" +
        Object.entries(query)
            .map((entry) => {
            return entry[0] + "=" + entry[1];
        })
            .join("&");
    redirectTo(url + queryString);
};
const redirectWithSessionStoragePayload = (url, payload) => {
    if (payload)
        sessionStorageProxy.setItem("REDIRECTION_PAYLOAD", payload);
    redirectTo(url);
};
export { configureRouter, redirectTo, redirectWithQueryTo, redirectWithSessionStoragePayload, triggerAction, };
